export * from "@/content/seo/schema-adapters";
export * from "@/content/seo/site-profile";
